// extracted by mini-css-extract-plugin
export var growableInput = "_5p-0";
export var tagContainer = "_5p-2";
export var textInput = "_5p-1";